// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer__TL9Uz {
  height: 315px;
  background: linear-gradient(79.42deg, #47a9f4 1.25%, #0e8eef 82.24%);
}

.Footer_row__-1bMG {
  display: grid;
  row-gap: 20px;
  grid-template-columns: 2fr 1fr 1fr;
  grid-template-rows: 120px 120px;
}

.Footer_logo__1dEML {
  width: 24%;
}

.Footer_logoImg__yFsfE {
  grid-row: 1/2;
  grid-column: 1/2;
  display: flex;
  align-items: flex-end;
  margin-left: 20%;
}

.Footer_socialIcons__yiYsC {
  grid-row: 2/3;
  grid-column: 1/2;
  width: 25%;
  display: flex;
  align-items: flex-start;
  gap: 25px;
  margin-left: 25.5%;
}

.Footer_rightScolumn__rDfWd {
  grid-row: 1/3;
  grid-column: 3/4;
  padding-bottom: 50px;
}
.Footer_leftScolumn__YiO8e {
  grid-row: 1/3;
  grid-column: 2/3;
  padding-bottom: 50px;
}
.Footer_leftScolumn__YiO8e,
.Footer_rightScolumn__rDfWd {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.Footer_divider__qMDY6 {
  border: 1px solid rgb(174, 217, 250, 0.5);
  width: 90%;
  margin: 0 auto;
}

.Footer_largeHeader__MN62L {
  font-family: "Open Sans";
  font-size: 20px;
  font-weight: 700;
  line-height: 27px;
  letter-spacing: 0px;
  color: #ffffff;
}

.Footer_link__yvgti {
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: 0px;
  text-decoration: none;
  color: rgb(264, 264, 264, 0.7);
}
.Footer_link__yvgti:hover {
  text-decoration: underline;
  color: white;
  cursor: pointer;
}

.Footer_Copyrights__Qh1o\\+ {
  font-family: Open Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0px;
  text-align: center;
  color: #aed9fa;
  padding-top: 10px;
  padding-bottom: 25px;
}

@media screen and (max-width: 1100px) {
  .Footer_logo__1dEML {
    width: 30%;
  }
}

@media screen and (max-width: 800px) {
  .Footer_footer__TL9Uz {
    height: -moz-fit-content;
    height: fit-content;
  }
  .Footer_row__-1bMG {
    grid-template-columns: 100%;
    grid-template-rows: 1fr 1fr 1fr 0.3fr;
    row-gap: 0px;
  }
  .Footer_logoImg__yFsfE {
    grid-row: 1/2;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 0;
  }

  .Footer_socialIcons__yiYsC {
    grid-row: 4/5;
    grid-column: 1/2;
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 25px;
    width: 100%;
    margin-left: 0;
  }

  .Footer_rightScolumn__rDfWd {
    grid-row: 2/3;
    grid-column: 1/2;
    display: flex;
    align-items: center;
  }
  .Footer_leftScolumn__YiO8e {
    grid-row: 3/4;
    grid-column: 1/2;
    display: flex;
    align-items: center;
  }
  .Footer_logo__1dEML {
    width: 30%;
  }
}

@media screen and (max-width: 450px) {
  .Footer_logo__1dEML {
    width: 50%;
  }
}

@media screen and (max-width: 426px) {
  .Footer_footer__TL9Uz {
    margin-top: 1875px;
  }
}

@media screen and (max-width: 376px) {
  .Footer_footer__TL9Uz {
    margin-top: 1840px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Footer/Footer.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oEAAoE;AACtE;;AAEA;EACE,aAAa;EACb,aAAa;EACb,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,oBAAoB;AACtB;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,0BAA0B;EAC1B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,wBAAmB;IAAnB,mBAAmB;EACrB;EACA;IACE,2BAA2B;IAC3B,qCAAqC;IACrC,YAAY;EACd;EACA;IACE,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".footer {\n  height: 315px;\n  background: linear-gradient(79.42deg, #47a9f4 1.25%, #0e8eef 82.24%);\n}\n\n.row {\n  display: grid;\n  row-gap: 20px;\n  grid-template-columns: 2fr 1fr 1fr;\n  grid-template-rows: 120px 120px;\n}\n\n.logo {\n  width: 24%;\n}\n\n.logoImg {\n  grid-row: 1/2;\n  grid-column: 1/2;\n  display: flex;\n  align-items: flex-end;\n  margin-left: 20%;\n}\n\n.socialIcons {\n  grid-row: 2/3;\n  grid-column: 1/2;\n  width: 25%;\n  display: flex;\n  align-items: flex-start;\n  gap: 25px;\n  margin-left: 25.5%;\n}\n\n.rightScolumn {\n  grid-row: 1/3;\n  grid-column: 3/4;\n  padding-bottom: 50px;\n}\n.leftScolumn {\n  grid-row: 1/3;\n  grid-column: 2/3;\n  padding-bottom: 50px;\n}\n.leftScolumn,\n.rightScolumn {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.divider {\n  border: 1px solid rgb(174, 217, 250, 0.5);\n  width: 90%;\n  margin: 0 auto;\n}\n\n.largeHeader {\n  font-family: \"Open Sans\";\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 27px;\n  letter-spacing: 0px;\n  color: #ffffff;\n}\n\n.link {\n  font-family: \"Open Sans\";\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 30px;\n  letter-spacing: 0px;\n  text-decoration: none;\n  color: rgb(264, 264, 264, 0.7);\n}\n.link:hover {\n  text-decoration: underline;\n  color: white;\n  cursor: pointer;\n}\n\n.Copyrights {\n  font-family: Open Sans;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 19px;\n  letter-spacing: 0px;\n  text-align: center;\n  color: #aed9fa;\n  padding-top: 10px;\n  padding-bottom: 25px;\n}\n\n@media screen and (max-width: 1100px) {\n  .logo {\n    width: 30%;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .footer {\n    height: fit-content;\n  }\n  .row {\n    grid-template-columns: 100%;\n    grid-template-rows: 1fr 1fr 1fr 0.3fr;\n    row-gap: 0px;\n  }\n  .logoImg {\n    grid-row: 1/2;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-left: 0;\n  }\n\n  .socialIcons {\n    grid-row: 4/5;\n    grid-column: 1/2;\n    display: flex;\n    align-items: baseline;\n    justify-content: center;\n    gap: 25px;\n    width: 100%;\n    margin-left: 0;\n  }\n\n  .rightScolumn {\n    grid-row: 2/3;\n    grid-column: 1/2;\n    display: flex;\n    align-items: center;\n  }\n  .leftScolumn {\n    grid-row: 3/4;\n    grid-column: 1/2;\n    display: flex;\n    align-items: center;\n  }\n  .logo {\n    width: 30%;\n  }\n}\n\n@media screen and (max-width: 450px) {\n  .logo {\n    width: 50%;\n  }\n}\n\n@media screen and (max-width: 426px) {\n  .footer {\n    margin-top: 1875px;\n  }\n}\n\n@media screen and (max-width: 376px) {\n  .footer {\n    margin-top: 1840px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__TL9Uz`,
	"row": `Footer_row__-1bMG`,
	"logo": `Footer_logo__1dEML`,
	"logoImg": `Footer_logoImg__yFsfE`,
	"socialIcons": `Footer_socialIcons__yiYsC`,
	"rightScolumn": `Footer_rightScolumn__rDfWd`,
	"leftScolumn": `Footer_leftScolumn__YiO8e`,
	"divider": `Footer_divider__qMDY6`,
	"largeHeader": `Footer_largeHeader__MN62L`,
	"link": `Footer_link__yvgti`,
	"Copyrights": `Footer_Copyrights__Qh1o+`
};
export default ___CSS_LOADER_EXPORT___;
